import D2C_Entity from './Entity'
import api from '@/api'
import store from '@/store'

class D2C_Role extends D2C_Entity {
  target = 'role'
  icon = 'tag'
  static objectType = 'entityType'
  static typeName = 'role'
  static fields = {
    actions: {
      default: {},
      label: 'Actions',
      path: 'actions',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      updatingAccess: {},
    },
    name: {
      default: '',
      label: 'Name',
      path: 'name',
      required: true,
      validate(value) {
        const regexp = /^[a-z0-9 ]{3,50}$/i
        if (!regexp.test(value)) {
          return 'Invalid name'
        }
        return null
      },
      creating: {},
      updating: {
        required: false,
      },
    },
  }
  static create(props) {
    return new D2C_Role(props)
  }
  get _actions() {
    const rules = {}
    const actions = ['accManagement', 'hostCreate', 'hostDestroy', 'hostInfo', 'hostTerminal', 'hostUpdate', 'hostUsage', 'keyCreate', 'keyDestroy', 'projectCreate', 'projectDestroy', 'projectExport', 'projectInfo', 'projectUpdate', 'projectUsage', 'providerCreate', 'providerDestroy', 'providerUpdate', 'serviceChangeProject', 'serviceDestroy', 'serviceInfo', 'serviceMoveContainer', 'serviceScale', 'serviceTerminal', 'serviceUpdate', 'tariffManagement']
    for (const action of actions) {
      rules[action] = this.actions[action]
    }
    return rules
  }
  get _members() {
    return store.getters.membersByRole[this.id]
  }
  create() {
    return api.createRole(this.getValues('creating'))
  }
  update(changes) {
    return api.updateRole(this.id, changes || this.getChanges())
  }
  delete() {
    return api.deleteRole(this.id)
  }
}

export default D2C_Role
